var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.62 26.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .g {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Group 3498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e",
    "data-name": "Path 1145"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "3.54 26.16 0 22.63 9.55 13.08 0 3.54 3.54 0 16.62 13.08 3.54 26.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f",
    "data-name": "Path 1146"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "13.54 26.16 10 22.63 19.55 13.08 10 3.54 13.54 0 26.62 13.08 13.54 26.16"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtn);
export default __webpack_public_path__ + "static/media/arrow_btn.ebb0dd75c0d9da12183bb19a67e7a9d6.svg";
export { ForwardRef as ReactComponent };